import mixpanel from 'mixpanel-browser'
mixpanel.init('438dd604ce9c0d72c36b3141913183bd', { debug: true })

export default mixpanel
